module.exports = __webpack_public_path__ + "static/iabs-d46954c588d77ff1104101b616af5993.pdf";